import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
	return Pathname.DASHBOARD_MANUFACTURING + name;
};
const GATE_REGISTER = 'gate-register';
const BILL_OF_MATERIAL = 'bill-of-material';
const DEMAND_PLANNING = 'demand-planning';
const PLANNING_AND_SCHEDULING = '/planning-and-scheduling';
const JOB_CARDS = 'job-cards';
const RECORD_COMPLETION = 'record-completion';
const ORDERS = '/orders';
const ITEMS = '/items';
const OPERATION_BLOCKS = 'operation-blocks';
const EQUIPMENT_FAILURE = '/equipment-failure';
const PLANS ="/plans"
const SETTINGS = '/settings';
const REPORTS = '/Reports'
const OPERATIONS = `operations`;
const WORK_CENTERS = `work-centers`;
const EQUIPMENTS = `equipments`;
const LOT_OR_SERIAL_NUMBER = `lot-serial-number`;
const WORK_CENTER_CATEGORIES = `work-center-categories`;
const ROUTING = `routing`;
const WIP_SETTINGS = `wip-settings`;
const BUILD_ORDER = `build-order`;
const MANAGE_OPERATIONS = `manage-operations`;
const UNBUILD_ORDER = `unbuild-order`;
const WORK_ORDER = `work-order`;
const MASTER_JOB_CARD = 'master-job-card';
const COST_ANALYSIS = `cost-analysis`;
const MATERIAL_ISSUE = 'material-issue';
const ACCOUNTING_LEDGER = 'accounting-ledger';
const PRODUCTION_PLAN = 'production-plans';
const PRODUCTION_PLAN_VIEW = 'production-plan-view'
const CREATE_SLIT_PLAN = 'create-slit-plans'
const FORMS = 'forms'
const CUSTOM_FORM = 'custom-form',
SLIT_PLAN_LISTING = "slit-plans-summary",
SLIT_PLAN_VIEW = "slit-plan-view",
SLIT_PLAN_EDIT = "slit-plan-edit"
const CREATE_SCAFFOLDING = 'create-scaffolding-plan';
const SCAFFOLDING_LISTING = "scaffoldings-summary";
const SCAFFOLDING_VIEW = "scaffolding-view";
const SCAFFOLDING_EDIT = "scaffolding-edit";

/* CRUD Routes */
export const gateEntriesCrudPaths = {
	ADD_GATE_REGISTER: `/${GATE_REGISTER}/add-${GATE_REGISTER}`,
	EDIT_GATE_REGISTER: `/${GATE_REGISTER}/:id/edit-${GATE_REGISTER}`,
	VIEW_GATE_REGISTER: `/${GATE_REGISTER}/:id/view-${GATE_REGISTER}`
};
export const billOfMaterialCrudPaths = {
	ADD_BILL_OF_MATERIAL: `/${BILL_OF_MATERIAL}/add-${BILL_OF_MATERIAL}`,
	EDIT_BILL_OF_MATERIAL: `/${BILL_OF_MATERIAL}/:id/edit-${BILL_OF_MATERIAL}`,
	VIEW_BILL_OF_MATERIAL: `/${BILL_OF_MATERIAL}/:id/view-${BILL_OF_MATERIAL}`
};
export const demandPlanningsCrudPaths = {
	ADD_DEMAND_PLANNING: `/${DEMAND_PLANNING}/add-${DEMAND_PLANNING}`,
	EDIT_DEMAND_PLANNING: `/${DEMAND_PLANNING}/edit-${DEMAND_PLANNING}`,
	VIEW_DEMAND_PLANNING: `/${DEMAND_PLANNING}/view-${DEMAND_PLANNING}`,
	DETAILS_DEMAND_PLANNIG: `/${DEMAND_PLANNING}/detail-${DEMAND_PLANNING}`
};
export const planningAndSchedulingCrudPaths = {
	ADD_PLANNING_AND_SCHEDULING: `${PLANNING_AND_SCHEDULING}/add-${PLANNING_AND_SCHEDULING}`,
	EDIT_PLANNING_AND_SCHEDULING: `${PLANNING_AND_SCHEDULING}/:id/edit-${PLANNING_AND_SCHEDULING}`,
	VIEW_PLANNING_AND_SCHEDULING: `${PLANNING_AND_SCHEDULING}/:id/view-${PLANNING_AND_SCHEDULING}`
};
export const jobCardsCrudPaths = {
	ADD_JOB_CARDS: `/${JOB_CARDS}/add-${JOB_CARDS}`,
	EDIT_JOB_CARDS: `/${JOB_CARDS}/:id/edit-job-card`,
	VIEW_JOB_CARDS: `/${JOB_CARDS}/:id/view-${JOB_CARDS}`,
	RECORD_COMPLETION: `/${JOB_CARDS}/:seriesNumber/${RECORD_COMPLETION}`,
	ADD_RECORD_COMPLETION: `/${JOB_CARDS}/:seriesNumber/add-${RECORD_COMPLETION}`,
	VIEW_RECORD_COMPLETION: `/${JOB_CARDS}/:seriesNumber/${RECORD_COMPLETION}/:id/view-${RECORD_COMPLETION}`,
};
export const ordersCrudPaths = {
	ADD_ORDERS: `${ORDERS}/add-${ORDERS}`,
	EDIT_ORDERS: `${ORDERS}/:id/edit-${ORDERS}`,
	VIEW_ORDERS: `${ORDERS}/:id/view-${ORDERS}`
};
export const itemsCrudPaths = {
	ADD_ITEMS: `${ITEMS}/add-${ITEMS}`,
	EDIT_ITEMS: `${ITEMS}/:id/edit-${ITEMS}`,
	VIEW_ITEMS: `${ITEMS}/:id/view-${ITEMS}`
};
export const operationBlocksCrudPaths = {
	ADD_OPERATION_BLOCKS: `/${OPERATION_BLOCKS}/add-${OPERATION_BLOCKS}`,
	EDIT_OPERATION_BLOCKS: `/${OPERATION_BLOCKS}/:id/edit-${OPERATION_BLOCKS}`,
	VIEW_OPERATION_BLOCKS: `/${OPERATION_BLOCKS}/:id/view-${OPERATION_BLOCKS}`,
	DETAIL_OPERATION_BLOCKS: `/${OPERATION_BLOCKS}/:id/detail-${OPERATION_BLOCKS}`
};
export const equipmentFailureCrudPaths = {
	ADD_EQUIPMENT_FAILURE: `${EQUIPMENT_FAILURE}/add-${EQUIPMENT_FAILURE}`,
	EDIT_EQUIPMENT_FAILURE: `${EQUIPMENT_FAILURE}/:id/edit-${EQUIPMENT_FAILURE}`,
	VIEW_EQUIPMENT_FAILURE: `${EQUIPMENT_FAILURE}/:id/view-${EQUIPMENT_FAILURE}`
};
export const operationCrudPaths = {
	ADD_OPERATIONS: `${SETTINGS}/${OPERATIONS}/add-${OPERATIONS}`,
	EDIT_OPERATIONS: `${SETTINGS}/${OPERATIONS}/:id/edit-${OPERATIONS}`,
	VIEW_OPERATIONS: `${SETTINGS}/${OPERATIONS}/:id/view-${OPERATIONS}`
};
export const workCenterCrudPaths = {
	ADD_WORK_CENTERS: `${SETTINGS}/${WORK_CENTERS}/add-${WORK_CENTERS}`,
	EDIT_WORK_CENTERS: `${SETTINGS}/${WORK_CENTERS}/:id/edit-${WORK_CENTERS}`,
	VIEW_WORK_CENTERS: `${SETTINGS}/${WORK_CENTERS}/:id/view-${WORK_CENTERS}`
};
export const equipmentsCrudPaths = {
	ADD_EQUIPMENTS: `${SETTINGS}/${EQUIPMENTS}/add-${EQUIPMENTS}`,
	EDIT_EQUIPMENTS: `${SETTINGS}/${EQUIPMENTS}/:id/edit-${EQUIPMENTS}`,
	VIEW_EQUIPMENTS: `${SETTINGS}/${EQUIPMENTS}/:id/view-${EQUIPMENTS}`
};
export const lotOrSerialNumberCrudPaths = {
	ADD_LOT_OR_SERIAL_NUMBER: `${SETTINGS}/${LOT_OR_SERIAL_NUMBER}/add-${LOT_OR_SERIAL_NUMBER}`,
	EDIT_LOT_OR_SERIAL_NUMBER: `${SETTINGS}/${LOT_OR_SERIAL_NUMBER}/:id/edit-${LOT_OR_SERIAL_NUMBER}`,
	VIEW_LOT_OR_SERIAL_NUMBER: `${SETTINGS}/${LOT_OR_SERIAL_NUMBER}/:id/view-${LOT_OR_SERIAL_NUMBER}`
};
export const workCenterCategoriesCrudPaths = {
	ADD_WORK_CENTER_CATEGORIES: `${SETTINGS}/${WORK_CENTER_CATEGORIES}/add-${WORK_CENTER_CATEGORIES}`,
	EDIT_WORK_CENTER_CATEGORIES: `${SETTINGS}/${WORK_CENTER_CATEGORIES}/:id/edit-${WORK_CENTER_CATEGORIES}`,
	VIEW_WORK_CENTER_CATEGORIES: `${SETTINGS}/${WORK_CENTER_CATEGORIES}/:id/view-${WORK_CENTER_CATEGORIES}`
};

export const customFormPath = {
	CUSTOM_FORM: `${SETTINGS}/${CUSTOM_FORM}`,
};

export const reportPaths = {
	COMPLATION_REPORTS:`${REPORTS}/Complation`,
	DETAIL_COMPLETION_REPORTS:`${REPORTS}/Completion/details`,
	COMPONENT_WHERE_USER:`${REPORTS}/Componentwhereused`,
	DETAIL_COMPONENT_WHERE_USER:`${REPORTS}/Componentwhereused/details`,
	BOM_INQUIRY:`${REPORTS}/BoMinquiry`,
	DETAIL_BOM_INQUIRY:`${REPORTS}/BoMinquiry/details`,
	FACTORY_CONSUMPTION_REPORT:`${REPORTS}/FactoryConsumption`,
	DETAIL_FACTORY_CONSUMPTION_REPORT:`${REPORTS}/FactoryConsumption/details`,
	COST_ROLLUP_REPORT:`${REPORTS}/CostRollup`,
	DETAIL_COST_ROLLUP_REPORT:`${REPORTS}/CostRollup/details`,
	SCRAP_REPORT:`${REPORTS}/scrap`,
	DETAIL_SCRAP_REPORT:`${REPORTS}/scrap/details`,
	DOWN_TIME_REPORT:`${REPORTS}/down-time`,
	WORK_ORDER_STATUS:`${REPORTS}/WorkOrderStatus`,
	DETAIL_WORK_ORDER_STATUS:`${REPORTS}/WorkOrderStatus/details`,
	WORK_ORDER_SCHEDULE:`${REPORTS}/WorkOrderSchedule`,
	WORK_CENTER_SCHEDULE:`${REPORTS}/WorkCenterSchedule`,
	SCHEDULE_REPORT:`${REPORTS}/schedule-report`,

}
export const routingCrudPaths = {
	ADD_ROUTING: `${SETTINGS}/${ROUTING}/add-${ROUTING}`,
	EDIT_ROUTING: `${SETTINGS}/${ROUTING}/:id/edit-${ROUTING}`,
	VIEW_ROUTING: `${SETTINGS}/${ROUTING}/:id/view-${ROUTING}`
};

export const buildOrderCrudPaths = {
	ADD_BUILD_ORDER: `${ORDERS}/${BUILD_ORDER}/add-${BUILD_ORDER}`,
	EDIT_BUILD_ORDER: `${ORDERS}/${BUILD_ORDER}/:id/edit-${BUILD_ORDER}`,
	VIEW_BUILD_ORDER: `${ORDERS}/${BUILD_ORDER}/:id/view-${BUILD_ORDER}`,
	BUILD_ORDER_ACCOUNTING_LEDGER: `${ORDERS}/${BUILD_ORDER}/${ACCOUNTING_LEDGER}` //Todo: Add this to the build order view page
};
export const workOrderCrudPaths = {
	ADD_WORK_ORDER: `${ORDERS}/${WORK_ORDER}/add-${WORK_ORDER}`,
	EDIT_WORK_ORDER: `${ORDERS}/${WORK_ORDER}/:id/edit-${WORK_ORDER}`,
	VIEW_WORK_ORDER: `${ORDERS}/${WORK_ORDER}/:id/view-${WORK_ORDER}`,
	MATERIAL_ISSUE: `${ORDERS}/${WORK_ORDER}/:seriesNumber/${MATERIAL_ISSUE}`,
	ADD_MATERIAL_ISSUE: `${ORDERS}/${WORK_ORDER}/:seriesNumber/${MATERIAL_ISSUE}/add-${MATERIAL_ISSUE}`,
	VIEW_MATERIAL_ISSUE: `${ORDERS}/${WORK_ORDER}/:seriesNumber/${MATERIAL_ISSUE}/view-${MATERIAL_ISSUE}`,
	BUIL_ORDER_OF_WO: `${ORDERS}/${WORK_ORDER}/:seriesNumber/${BUILD_ORDER}`,
	WORK_ORDER_COST_ANALYSIS: `${ORDERS}/${WORK_ORDER}/${COST_ANALYSIS}`,
	WORK_ORDER_ACCOUNTING_LEDGER: `${ORDERS}/${WORK_ORDER}/${ACCOUNTING_LEDGER}`
};

export const unbuildOrderCrudPaths = {
	ADD_UNBUILD_ORDER: `${ORDERS}/${UNBUILD_ORDER}/add-${UNBUILD_ORDER}`,
	EDIT_UNBUILD_ORDER: `${ORDERS}/${UNBUILD_ORDER}/:id/edit-${UNBUILD_ORDER}`,
	VIEW_UNBUILD_ORDER: `${ORDERS}/${UNBUILD_ORDER}/:id/view-${UNBUILD_ORDER}`,
	VIEW_UNBUILD_ORDER_LEADGER:`${ORDERS}/${UNBUILD_ORDER}/${ACCOUNTING_LEDGER}`
};

/* BASE Routes */
export const gateRegisterPaths = {
	GATE_REGISTER: `/${GATE_REGISTER}`,
	...gateEntriesCrudPaths
};
export const billOfMaterialPaths = {
	BILL_OF_MATERIALS: `/${BILL_OF_MATERIAL}`,
	...billOfMaterialCrudPaths
};
export const demandPlanningsPaths = {
	DEMAND_PLANNING: `/${DEMAND_PLANNING}`,
	...demandPlanningsCrudPaths
};
export const operationBlockPath = {
	OPERATION_BLOCKS: `/${OPERATION_BLOCKS}`,
	...operationBlocksCrudPaths
};
export const planningAndSchedulingPaths = {
	PLANNING_AND_SCHEDULING: `/${PLANNING_AND_SCHEDULING}`,
	...planningAndSchedulingCrudPaths
};
export const jobCardsPaths = {
	JOB_CARDS: `/${JOB_CARDS}`,
	...jobCardsCrudPaths
};
// export const ordersPaths = {
// 	ORDERS,
// 	...ordersCrudPaths
// };
export const itemsPaths = {
	ITEMS,
	...itemsCrudPaths
};

export const equipmentFailurePaths = {
	EQUIPMENT_FAILURE,
	...equipmentFailureCrudPaths
};
export const operationPaths = {
	OPERATIONS: `${SETTINGS}/${OPERATIONS}`,
	...operationCrudPaths
};
export const workCenterPaths = {
	WORK_CENTERS: `${SETTINGS}/${WORK_CENTERS}`,
	...workCenterCrudPaths
};
export const equipmentsPaths = {
	EQUIPMENTS: `${SETTINGS}/${EQUIPMENTS}`,
	...equipmentsCrudPaths
};
export const lotOrSerialNumberPaths = {
	LOT_OR_SERIAL_NUMBER: `${SETTINGS}/${LOT_OR_SERIAL_NUMBER}`,
	...lotOrSerialNumberCrudPaths
};
export const workCenterCategoriesPaths = {
	WORK_CENTER_CATEGORIES: `${SETTINGS}/${WORK_CENTER_CATEGORIES}`,
	...workCenterCategoriesCrudPaths
};
export const routingPaths = {
	ROUTING: `${SETTINGS}/${ROUTING}`,
	...routingCrudPaths
};
export const wipSettingsPaths = {
	WIP_SETTINGS: `${SETTINGS}/${WIP_SETTINGS}`
};

export const buildOrderPaths = {
	BUILD_ORDER: `${ORDERS}/${BUILD_ORDER}`,
	BUILD_ORDER_COST_ANALYSIS: `${ORDERS}/${BUILD_ORDER}/${COST_ANALYSIS}`,
	...buildOrderCrudPaths
};
export const productionPlanPaths = {
	PRODUCTION_PLAN: `${PLANS}/${PRODUCTION_PLAN}`,
	PRODUCTION_PLAN_VIEW: `${PLANS}/${PRODUCTION_PLAN}/:id/${PRODUCTION_PLAN_VIEW}`
};
export const slitPlanPaths = {
	CREATE_SLIT_PLAN: `${PLANS}/${CREATE_SLIT_PLAN}`,
	SLIT_PLAN_LISTING:`${PLANS}/${SLIT_PLAN_LISTING}`,
	SLIT_PLAN_VIEW:`${PLANS}/${SLIT_PLAN_LISTING}/:id/${SLIT_PLAN_VIEW}`,
	SLIT_PLAN_EDIT:`${PLANS}/${SLIT_PLAN_LISTING}/:id/${SLIT_PLAN_EDIT}`
};
export const scafFoldingPlanPaths = {
	CREATE_SCAFFOLDING: `${PLANS}/${CREATE_SCAFFOLDING}`,
	SCAFFOLDING_LISTING:`${PLANS}/${SCAFFOLDING_LISTING}`,
	SCAFFOLDING_VIEW:`${PLANS}/${SCAFFOLDING_LISTING}/:id/${SCAFFOLDING_VIEW}`,
	SCAFFOLDING_EDIT:`${PLANS}/${SCAFFOLDING_LISTING}/:id/${SCAFFOLDING_EDIT}`
};

export const manageOperationPaths = {
	MANAGE_OPERATIONS: `${ORDERS}/${MANAGE_OPERATIONS}`
};
export const unbuildOrderPaths = {
	UNBUILD_ORDER: `${ORDERS}/${UNBUILD_ORDER}`,
	...unbuildOrderCrudPaths
};
export const workOrderPaths = {
	WORK_ORDER: `${ORDERS}/${WORK_ORDER}`,
	...workOrderCrudPaths
};

export const masterJobCardCrudPaths = {
	ADD_MASTER_JOB_CARD: `/${MASTER_JOB_CARD}/add-master-job-card`,
	VIEW_MASTER_JOB_CARD: `/${MASTER_JOB_CARD}/:id/view-master-job-card`,
};

export const masterJobCardPaths = {
	MASTER_JOB_CARD: `/${MASTER_JOB_CARD}`,
	...masterJobCardCrudPaths,
};

export const formSettingsPaths = {
	FORMS: `${SETTINGS}/${FORMS}`,
	...customFormPath
}

const settingsRoutes = {
	...operationPaths,
	...workCenterPaths,
	...equipmentsPaths,
	...lotOrSerialNumberPaths,
	...workCenterCategoriesPaths,
	...routingPaths,
	...wipSettingsPaths,
	...formSettingsPaths
};

const orderingRoutes = {
	...buildOrderPaths,
	...unbuildOrderPaths,
	...workOrderPaths,
	...manageOperationPaths
};
const planRoutes = {
	...productionPlanPaths,
	...slitPlanPaths,
	...scafFoldingPlanPaths
};

export const PathnameManufacturing = {
	LANDING_PAGE: '/',
	LIST: '/list',
	...gateRegisterPaths,
	...billOfMaterialPaths,
	...demandPlanningsPaths,
	...operationBlockPath,
	...planningAndSchedulingPaths,
	...jobCardsPaths,
	// ...ordersPaths,
	...itemsPaths,
	...equipmentFailurePaths,
	...settingsRoutes,
	...orderingRoutes,
	...reportPaths,
	...planRoutes,
	...masterJobCardPaths,
};
